import React from 'react';
import { NetworkStatus, useMutation } from '@apollo/client';
import { CircularProgress, LinearProgress, TablePagination, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, IconButton, Grid } from "@mui/material";
import LocalProvider from "../../../../components/LocalProvider";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { DELETE_SUPERVISOR } from '../../../../graphql/mutations'

export default function List({ loading, error, data, networkStatus, currentPage, setCurrentPage, rowsPerPage, setRowsPerPage, onEdit, onDelete }) {

  const [deleteSupervisor, { loading: loadingDelete }] = useMutation(DELETE_SUPERVISOR);

  if (loading) return <CircularProgress style={{ margin: 12 }} />;
  if (error) return <div>{error}</div>;

  const handleEdit = (item) => {
    onEdit(item)
  }

  const handleDelete = (item) => {

    deleteSupervisor({ 
      variables: { 
        id: item.id 
      } 
    })
    .then(() => onDelete())
  }

  return (
    <>
      <TableContainer>
        {networkStatus === NetworkStatus.refetch && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Gerente</TableCell>
              <TableCell>&nbsp;</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              data.fetchSupervisors.data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.manager ? row.manager.user.name : '-'}</TableCell>
                  <TableCell>
                    <Grid container justifyContent="flex-end">
                      <Grid item>
                        <IconButton aria-label="edit" onClick={() => handleEdit(row)}>
                          <EditIcon />
                        </IconButton>
                      </Grid>
                      <Grid item>
                        <IconButton 
                          aria-label="delete" 
                          onClick={() => handleDelete(row)}>
                          { loadingDelete ? <CircularProgress size={21} /> : <DeleteIcon />}
                        </IconButton>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              ))
            }

            {
              data.fetchSupervisors.data.length == 0 &&
              <TableRow>
                <TableCell colSpan={2}>Nenhum supervisor cadastrado</TableCell>
              </TableRow>
            }

          </TableBody>
        </Table>
      </TableContainer>

      <LocalProvider locale="ptBR">
        <TablePagination
            showFirstButton
          showLastButton        
          rowsPerPageOptions={[8, 32, 100]}
          component="div"
          count={data.fetchSupervisors.total}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => {
            setCurrentPage(newPage);
          }}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setCurrentPage(0);
          }}
        />
      </LocalProvider>
    </>
  );
}